import { ConversationInsightsFiltersV1Schema } from "@redotech/redo-support-common/conversation-filters/conversation-insights-filters";
import * as z from "zod";

export const getConversationInsightsCount = {
  name: "getConversationInsightsCount" as const,
  input: z.object({ filters: ConversationInsightsFiltersV1Schema.optional() }),
  output: z.object({ count: z.int().min(0) }),
};
